import { FC, ReactNode } from 'react';
import { useTranslation } from 'hooks';
import { Chip } from 'shared/ui/chip/chip';
import { Icon } from 'shared/ui/icon/icon';
import { ICONS } from 'shared/constants/images';
import { Filter } from 'shared/constants/color-filters';
import { RunBlockStatus } from 'shared/hooks/useReportProgress';
import cls from './run-status-chip.module.scss';

interface RunStatusChipProps {
  status: RunBlockStatus;
}

const CHIP_TONE = {
  queued: 'neutral',
  'in-progress': 'info',
  ready: 'success',
} as const;

const CHIP_LABEL_KEY = {
  queued: 'inQueue',
  'in-progress': 'analyzing',
  ready: 'readyToUse',
} as const;

const CHIP_ICON: Record<RunBlockStatus, ReactNode> = {
  queued: (
    <Icon pathToIcon={ICONS.clock} size={16} filter={Filter.onSurfaceVariant} />
  ),
  'in-progress': undefined,
  ready: <Icon pathToIcon={ICONS.checkCircle} size={16} />,
};

export const RunStatusChip: FC<RunStatusChipProps> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <Chip
      color={CHIP_TONE[status]}
      icon={CHIP_ICON[status]}
      className={cls.runStatusChip}
    >
      {t(CHIP_LABEL_KEY[status])}
    </Chip>
  );
};
